import { render, staticRenderFns } from "./menu-item.vue?vue&type=template&id=f61548be&"
import script from "./menu-item.vue?vue&type=script&lang=js&"
export * from "./menu-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f61548be')) {
      api.createRecord('f61548be', component.options)
    } else {
      api.reload('f61548be', component.options)
    }
    module.hot.accept("./menu-item.vue?vue&type=template&id=f61548be&", function () {
      api.rerender('f61548be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menu/menu-item.vue"
export default component.exports